import I18n from 'i18n-react';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, ControlLabel, Row } from 'react-bootstrap';
import { leftPad } from '../../utils/ParseUtils';
import ImageFallback from '../../common/imageFallback/ImageFallback';
import Baggage from '../../flightSelection/baggage/Baggage';
import './FlightList.css';
import moment from 'moment';

const propTypes = {
  id: PropTypes.string.isRequired,
  flights: PropTypes.arrayOf(
    PropTypes.shape({
      flightNumber: PropTypes.number,
      origin: PropTypes.string,
      destination: PropTypes.string,
      departureTime: PropTypes.arrayOf(PropTypes.number),
      arrivalTime: PropTypes.arrayOf(PropTypes.number),
      dateVariation: PropTypes.number,
      operatingCarrier: PropTypes.string,
      throughFlight: PropTypes.bool,
      hasExchangeAirport: PropTypes.bool,
      baggage: PropTypes.arrayOf(
        PropTypes.shape({
          category: PropTypes.string.isRequired,
          quantity: PropTypes.number,
          weight: PropTypes.number
        })
      )
    })
  ),
  category: PropTypes.string,
  baggage: PropTypes.shape({
    quantity: PropTypes.number,
    weight: PropTypes.number
  })
};

const defaultProps = {
  baggage: {
    quantity: 0,
    weight: 0
  }
};

class FlightList extends React.Component {
  constructor(props) {
    super(props);
  }

  getLabelConnectionDesktop(hasExchangeAirport, index, flights) {
    let label;

    if (hasExchangeAirport) {
      label = (
        <Row>
          <Col xs={12} xsHidden className="no-padding">
            <i className="FlightList__iconAirportChange" />
            <label className="FlightList__connectionLabel FlightList__connectionLabelWithAirportExchange">
              {I18n.translate(
                this.verifyOriginAirportNameAndDestinationAirportName(flights, index)
              )}
            </label>
            <div className="FlightList__connectionLine FlightList__connectionLineWithAirportExchange" />
          </Col>
        </Row>
      );
    } else {
    label = (
        <Row>
          <Col xs={12} xsHidden className="no-padding">
            <label className="FlightList__connectionLabel FlightList__connectionAndThroughFlight">
                {this.verifyIsThroughFlight(index, flights)}
            </label>
            <div className="FlightList__connectionLine FlightList__connectionOnly" />
          </Col>
        </Row>
      );
    }
    
    return label;
  }

  getLabelConnectionMobile(hasExchangeAirport, index, flights) {
    let label;

    if (hasExchangeAirport) {
      label = (
        <Row className="FlightList__connectionLineContainer">
          <Col xs={2} smHidden mdHidden lgHidden>
            <div className="FlightList__connectionLine FlightList__connectionLineWithAirportExchange__left" />
          </Col>
          <Col xs={8} smHidden mdHidden lgHidden className="text-center connectionLabelDescription">
            <i className="FlightList__iconAirportChange" />
            <label className="FlightList__connectionLabel FlightList__connectionLabelWithAirportExchange">
              {this.verifyOriginAirportNameAndDestinationAirportName(flights, index)}
            </label>
          </Col>
          <Col xs={2} smHidden mdHidden lgHidden>
            <div className="FlightList__connectionLine FlightList__connectionLineWithAirportExchange__right" />
          </Col>
        </Row>
      );
    } else (
      label = (
      <Row className="FlightList__connectionLineContainer">
        <Col xs={4} smHidden mdHidden lgHidden>
          <div className="FlightList__connectionLine FlightList__connectionLine__left" />
        </Col>
        <Col xs={4} smHidden mdHidden lgHidden className="text-center connectionLabelDescription">
          <label className="FlightList__connectionLabel">
            <p>{this.verifyIsThroughFlight(index, flights)}</p>
          </label>
        </Col>
        <Col xs={4} smHidden mdHidden lgHidden>
          <div className="FlightList__connectionLine FlightList__connectionLine__right" />
        </Col>
      </Row>
      )
    );
    
    return label;
  }

  verifyIsThroughFlight(index, flightGroup) {
    const waitingTime = this.calculateWaitingTimes(index);
  
    if (flightGroup[index].throughFlight) {
      return I18n.translate('components.flightDetailsModal.messageConnection', {
        time: <strong>{waitingTime}</strong>
      });
    } else {
      return I18n.translate('components.flightDetailsModal.messageAirplaneChange', {
        time: <strong>{waitingTime}</strong>
      });
    }
  }

  calculateWaitingTimes() {
    const format = 'HH:mm';

    for (let i = 0; i < this.props.flights.length - 1; i++) {
      const arrivalTime = moment(this.props.flights[i].arrivalTime, format);
      const nextDepartureTime = moment(this.props.flights[i + 1].departureTime, format);

      let waitingTime = moment.duration(nextDepartureTime.diff(arrivalTime));

      if (waitingTime.asMinutes() < 0) {
        waitingTime = moment.duration(nextDepartureTime.add(1, 'day').diff(arrivalTime));
      }

      const hours = Math.floor(waitingTime.asHours());
      const minutes = waitingTime.minutes();

      return hours > 0 ? `${hours}h ${minutes}min` : `${minutes}min`;
    }
  }

  verifyOriginAirportNameAndDestinationAirportName(flightgroup, index) {
    const departureAirport = flightgroup[index].origin;
    const arrivalAirport = index === 0 ? flightgroup[index].destination : flightgroup[index - 1].destination;
    let result = '';

    arrivalAirport === departureAirport 
    ? result = I18n.translate('components.resume.stopFlight', {
        time: this.calculateWaitingTimes(index)
      }) 
    : result = I18n.translate('components.flightDetailsModal.messageAirportChange', {
      time: this.calculateWaitingTimes(index)
    });
     
    return result;
  }

  printTimeHHMM(hour, minute) {
    if (typeof hour === 'number' && typeof minute === 'number') {
      return leftPad(hour, 2) + ':' + leftPad(minute, 2);
    }
  }

  renderCheckInLabel(key) {
    return (
      <Col sm={12} xsHidden className="FlightList__checkin">
        <div className="FlightList__tableCell">
          <i className="FlightList__checkinIcon" />
          <label className="FlightList__checkinLabel">
            {I18n.translate('components.resume.checkin')}
          </label>
        </div>
      </Col>
    );
  }

  getPlusDays(dateVariation) {
    if (dateVariation) {
      const plusDays = dateVariation;
      let formatPlusDays = `+${plusDays} ${I18n.translate(`components.flightTime.day`)}`;
      if (plusDays > 1) {
        formatPlusDays = `+${plusDays} ${I18n.translate(`components.flightTime.days`)}`;
      }
      return formatPlusDays;
    }
  }

  getCategory(cabinCategory) {
    if(cabinCategory !== 'C'){
      return 'ECONOMY'
    }
    return 'BUSINESS'
  }

  renderDesktop(flightGroup, key, index) {
    return (
      <div key={key} id={`flightListGroup-${key}`}>
        {this.getLabelConnectionDesktop(flightGroup.hasExchangeAirport, index, this.props.flights)}
        <Row className="FlightList__connectionContainer">
          <Col className="FlightList__flightColumn" sm={5} xsHidden>
            <div className="FlightList__tableCell">
              <div className="FlightList__flightTime FlightList__tableCell">
                <label className="FlightList__time originTime">
                  {this.printTimeHHMM.apply(this, flightGroup.departureTime)}
                </label>
                <label className="FlightList__airport originCode"> {flightGroup.origin}</label>
              </div>
              <div className="FlightList__divSeparator">
                <div className="FlightList__arrowIcon" />
              </div>
              <div className="FlightList__flightTime FlightList__tableCell">
                <label className="FlightList__time departureTime">
                  {this.printTimeHHMM.apply(this, flightGroup.arrivalTime)}
                </label>
                <label className="FlightList__airport departureCode">
                  {' '}
                  {flightGroup.destination}
                </label>
                <ControlLabel className="FlightList__plusDays plusDays" id="lblPlusDays">
                  {this.getPlusDays(flightGroup.dateVariation)}
                </ControlLabel>
              </div>
            </div>
          </Col>
          <Col sm={2} xsHidden>
            <div className="FlightList__tableCell">
              <label className="FlightList__flightNumber FlightList__flight">
                {I18n.translate('components.resume.flight')}
              </label>
              <label className="FlightList__flightNumber operatingCarrier">
                {flightGroup.operatingCarrier}
              </label>
              <label className="FlightList__flightNumber flightNumber">
                {flightGroup.flightNumber}
              </label>
            </div>
          </Col>
          <Col sm={2} xsHidden>
            <div className="FlightList__tableCell">
              <label className="FlightList__operateBy">
                {' '}
                {I18n.translate('components.resume.marketingBy')}{' '}
              </label>
              <ImageFallback
                className="FlightList__marketingCarrierImg"
                src={`styles/img/imgVendidoPor${flightGroup.marketingCarrier}-2.png`}
                alt={flightGroup.marketingCarrier}
              />
            </div>
          </Col>
          <Col sm={1} xsHidden>
            <label className="FlightList__category FlightList__tableCell">
              {I18n.translate('components.resume.' + this.getCategory(flightGroup.cabinCategory))}
            </label>
          </Col>
          <Col sm={2} xsHidden>
            <div id="baggageInfoCell" className="FlightList__tableCell">
              <Baggage
                id={`baggageInfoResume-${index}`}
                quantity={this.props.baggage.quantity}
                weight={this.props.baggage.weight}
                displayIcon={false}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }

  renderMobile(flightGroup, key, index) {
    return (
      <div key={key} id={`flightListGroup-${key}`}>
        {this.getLabelConnectionMobile(flightGroup.hasExchangeAirport, index, this.props.flights)}

        <Row>
          <Col xs={12} smHidden mdHidden lgHidden className="FlightList__flightNumber">
            <label className="FlightList__flightNumber FlightList__flight">
              {I18n.translate('components.resume.flight')}
            </label>
            <label className="FlightList__flightNumber operatingCarrier">
              {flightGroup.operatingCarrier}
            </label>
            <label className="FlightList__flightNumber flightNumber">
              {flightGroup.flightNumber}
            </label>
          </Col>
        </Row>

        <Row>
          <Col xs={6} smHidden mdHidden lgHidden>
            <label className="FlightList__category">
              {I18n.translate('components.resume.' + this.getCategory(flightGroup.cabinCategory))}
            </label>
          </Col>
          <Col xs={6} smHidden mdHidden lgHidden className="text-right">
            <ImageFallback
              className="text-right FlightList__image"
              src={`styles/img/imgVendidoPor${flightGroup.marketingCarrier}.png`}
              alt={flightGroup.marketingCarrier}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={5} smHidden mdHidden lgHidden>
            <label className="FlightList__time originTime">
              {this.printTimeHHMM.apply(this, flightGroup.departureTime)}
            </label>
            <label className="FlightList__airport originCode"> {flightGroup.origin}</label>
          </Col>
          <Col xs={2} smHidden mdHidden lgHidden>
            <div className="FlightList__arrowIcon" />
          </Col>
          <Col xs={5} smHidden mdHidden lgHidden className="text-right">
            <label className="FlightList__time departureTime">
              {this.printTimeHHMM.apply(this, flightGroup.arrivalTime)}
            </label>
            <label className="FlightList__airport departureCode"> {flightGroup.destination}</label>
            <ControlLabel className="FlightList__plusDays" id="lblPlusDays">
              {this.getPlusDays(flightGroup.dateVariation)}
            </ControlLabel>
          </Col>
        </Row>
      </div>
    );
  }

  render() {
    return (
      <div>
        <Row id={this.props.id}>
          <Col xs={12} className="FlightList__container">
            {this.props.flights.map((flightGroup, key) => {
              let flights = [];
              flights.push(this.renderDesktop(flightGroup, key + 'desktop', key));
              flights.push(this.renderMobile(flightGroup, key + 'mobile', key));
              return flights;
            })}
          </Col>
        </Row>
        {this.renderCheckInLabel(0)}
      </div>
    );
  }
}

FlightList.propTypes = propTypes;
FlightList.defaultProps = defaultProps;

export default FlightList;



// WEBPACK FOOTER //
// ./src/components/bookingResume/flightList/FlightList.jsx